import type { RESUME_TOKEN_QUERY_KEY } from "~/assets/constants";
import { buildHostUrl, buildUrl as buildDomainUrl, buildPhotosEmailAddress, buildBranchEmailAddress, buildVisaCountryPageUrl, isAbsolutePath, buildSuccessRoute, isBlogPostRoute } from "~/helpers/routing";
import type { CountryKey, PaymentProcessor } from "~/types";

interface QueryKeyToType {
  form_id: string;
  country_key: CountryKey;
  coupon: string;
  payment_processor: PaymentProcessor;
  payment_intent_client_secret: string;
  yclid: string;
  [RESUME_TOKEN_QUERY_KEY]: string;
  immediate_session_recording: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  ref: string;
};

export default function useRouting() {
  const branchCode = useBranch().code;
  const { $domain } = useNuxtApp();
  const route = useRoute();
  const router = useRouter();

  return {
    buildUrl,
    hostUrl: buildHostUrl($domain),
    fullUrl: buildUrl(route.fullPath),
    photosEmailAddress: buildPhotosEmailAddress($domain),
    branchEmailAddress: buildBranchEmailAddress(branchCode),
    isBlogPost: computed(() => isBlogPostRoute(route.path)),
    buildVisaCountryUrl: (c: CountryKey) => buildVisaCountryPageUrl($domain, c),
    toAbsolute: (path: string) => isAbsolutePath(path) ? path : buildUrl(path),

    buildSuccessRoute: (formId: string, country: CountryKey, processor: PaymentProcessor) => {
      return buildSuccessRoute(formId, country, processor, route.query as Record<string, string>);
    },

    getQueryParam<T extends keyof QueryKeyToType>(key: T) {
      return route.query[key] as QueryKeyToType[T] | null;
    },

    clearQueryParam<T extends keyof QueryKeyToType>(key: T) {
      const query = Object.assign({}, route.query);
      delete query[key];
      router.replace({ query });
    }
  };

  function buildUrl(path: string) {
    return buildDomainUrl($domain, path);
  }
}